import React from "react";
import { Form, Input } from "antd";
import { BiMap } from "react-icons/bi";

const UserAdressPostCode = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="postCode" label="Post Code" rules={[]}>
      <Input
        type="number"
        prefix={<BiMap className="form-item-icon" />}
        placeholder="Post Code"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default UserAdressPostCode;
